import {useState} from 'react';
import {StyleSheet, Image, View} from 'react-native';
import {useImagePreload} from 'interface/hooks/useImagePreload';

export interface FileImageProps {
  large?: boolean,
  source?: string,
  onError?: () => void,
}

export function FileImage(props: FileImageProps) {
  const [loaded, setLoaded] = useState(false);
  const image = useImagePreload(props.source);
  const classes = {
    root: [
      styles.root,
      props.large && styles.large,
    ],
    image: [
      styles.image,
      loaded && styles.loaded,
      props.large && styles.large,
    ],
  };

  return (
    <View style={classes.root}>
      {!!image &&
        <Image
          style={classes.image}
          source={{uri: image}}
          onError={props.onError}
          onLoad={() => setLoaded(true)}
          resizeMode="contain"
        />
      }
    </View>
  );
}

export const styles = StyleSheet.create({
  root: {
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    width: 32,
    height: 38,
    flex: 1,
  },
  large: {
    width: 84,
    height: 74,
  },
  image: {
    width: 32,
    height: 38,
    opacity: 0,
    // transition: '.2s opacity', TODO: WEB ONLY
    position: 'relative',
  },
  loaded: {
    opacity: 1,
  }
});
